import { MarkerPin01 } from '@untitled-ui/icons-react'
import { useBus } from 'react-bus'
import useUserLocation from '@/hooks/useUserLocation'

export default function SidebarLocationButton() {
    const bus = useBus()
    const { userLocation, userPrinter } = useUserLocation()

    return (
        <div
            onClick={() => bus.emit('openCurrentLocation')}
            className="flex items-center gap-3 px-4 rounded-xl py-2.5 h-[38px] hover:bg-gray-100 transition-colors cursor-pointer"
        >
            <MarkerPin01 width={18} height={18} className="shrink-0 text-gray-400" />
            <span className="text-sm text-gray-600 truncate">
                {userLocation?.name || 'Emplacement'}{userPrinter ? ` · ${userPrinter.name}` : ''}
            </span>
        </div>
    )
}
